export default __webpack_public_path__ + "static/banner-how-travel-opens-your-mind-f5cc62afa30cdf40450112b64e970186.jpg";